/**
 * 向上取整
 * @param {原数字} num
 * @param {保留的小数位数} fix
 * @returns
 */
function upFixed(num, fix) {
  let result = '0'
  if (Number(num) && fix > 0) {
    // 简单的做个判断
    fix = +fix || 2
    num = num + ''
    if (/e/.test(num)) {
      // 如果是包含e字符的数字直接返回
      result = num
    } else if (!/\./.test(num)) {
      // 如果没有小数点
      result = num + `.${Array(fix + 1).join('0')}`
    } else {
      // 如果有小数点
      num = num + `${Array(fix + 1).join('0')}`
      const reg = new RegExp(`-?\\d*\\.\\d{0,${fix}}`)
      const floorStr = reg.exec(num)[0]
      if (+floorStr >= +num) {
        result = floorStr
      } else {
        const floorNumber = +floorStr + +`0.${Array(fix).join('0')}1`
        const point = /\./.test(floorNumber + '') ? '' : '.'
        const floorStr2 = floorNumber + point + `${Array(fix + 1).join('0')}`
        result = reg.exec(floorStr2)[0]
      }
    }
  }
  return result
}
const oVueFilter = {
  // 截取小数点后n位
  toFixedFn(val, num) {
    if (num) {
      const realVal = Number(val).toFixed(num)
      return realVal
    } else {
      return val
    }
  },

  dateFormate(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
      year,
      month,
      day,
      hour,
      min,
      sec
    ].map(item => (item < 10 ? '0' + item : item))
    return `${year}-${month}-${day} ${hour}:${min}:${sec}`
  },
  dateFormateMin(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
      year,
      month,
      day,
      hour,
      min,
      sec
    ].map(item => (item < 10 ? '0' + item : item))
    return `${hour}:${min}`
  },
  dateFormateDay(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    if (timer) {
      var newTimer = timer
      const date = new Date(newTimer)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds();
      [year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
      ].map(item => (item < 10 ? '0' + item : item))
      return `${year}-${month}-${day}`
    } else {
      return ''
    }
  },
  dateFormateSfDay(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    if (timer) {
      var newTimer = timer
      const date = new Date(newTimer)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let min = date.getMinutes()
      let sec = date.getSeconds();
      [year, month, day, hour, min, sec] = [
        year,
        month,
        day,
        hour,
        min,
        sec
      ].map(item => (item < 10 ? '0' + item : item))
      return `${year}-${month}-${day} ${hour}:${min}`
    } else {
      return ''
    }
  },
  dateFormateDayCh(timer) {
    // var timezone = 8; //目标时区时间，东八区
    // var offset_GMT = new Date().getTimezoneOffset();
    // var offset_GMT_Time = -offset_GMT/60;
    // var newTimer = Number(timer)-(offset_GMT_Time-timezone)*60*60*1000
    var newTimer = timer
    const date = new Date(newTimer)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let min = date.getMinutes()
    let sec = date.getSeconds();
    [year, month, day, hour, min, sec] = [
      year,
      month,
      day,
      hour,
      min,
      sec
    ].map(item => (item < 10 ? '0' + item : item))
    return `${year}年${month}月${day}日`
  },
  // 1-订立，2-转让，4-强制转让，15-到期转让
  tradeTypeFormat(t) {
    switch (Number(t)) {
      case 1:
        return '订立'

      case 2:
        return '转让'

      case 4:
        return '代为转让'

      case 6:
        return '提前交收'

      case 7:
        return '到期交收'

      case 15:
        return '到期转让'

      default:
        return t
    }
  },
  //
  deliverTypeFormate(t) {
    switch (t) {
      case 1:
        return '协议交收'

      case 2:
        return '到期交收'

      case 3:
        return '强制减仓'

      default:
        return '未知'
    }
  },
  // 出库状态
  deliveryStatus(val) {
    // w 待发货 s 已发货 u 已撤销
    if (val == 'W') {
      return '待出库'
    } else if (val == 'S') {
      return '已出库'
    }
  },
  // 我的交收申请查询状态
  seletApplyStatus(val) {
    // w 待发货 s 已发货 u 已撤销
    if (val == 'Y') {
      return '未撤销'
    } else if (val == 'U') {
      return '已撤销'
    }
  },
  // 物流提货状态
  pickStatus(val) {
    // w 待发货 s 已发货 u 已撤销 Y 已收货
    if (val == 'W') {
      return '待发货'
    } else if (val == 'S') {
      return '已发货'
    } if (val == 'Y') {
      return '已收货'
    }
  },
  // 企业认证状态
  BankSignStatus(id) {
    let statusName = null
    switch (id) {
      case 0:
        statusName = '请前往签约页面进行签约!'
        break
      case 1:
        statusName = ''
        break
      case 2:
        statusName = '解约成功'
        break
      case 3:
        statusName = '您的签约正在申请中,请耐心等待结果!'
        break
      case 4:
        statusName = '您的解约正在申请中,请耐心等待结果!'
        break
      case 5:
        statusName = '绑卡出错'
        break
      case 6:
        statusName =
                    '打款验证出错,请前往入金记录页面获取第一次入金流水号,并在此页面点击打款验证输入认证金额及流水号'
        break
      case 7:
        statusName = '解绑在途'
        break
      case 8:
        statusName = '解绑出错'
        break
      case 11:
        statusName = '绑卡在途'
        break
      case 12:
        statusName = '打款验证在途'
        break
      case 13:
        statusName =
                    '机构绑卡成功,请去网银端入金,并前往银行签约界面进行打款验证'
        break
      default:
        statusName = '--'
        break
    }
    return statusName
  },
  toThousands(numT) {
    let num = numT
    if (typeof num === 'number' && !isNaN(num)) {
      if (num < 0) {
        return 0
      }
      num = num.toString()
      var sign = ''
      if (num[0] == '-') {
        num = num.slice(1)
        sign = '-'
      }

      var result = ''
      num = Number(num.toString() || 0).toFixed(2)
      var numAry = num.toString().split('.')
      var preNum = numAry[0]
      var lastNum = numAry[1]
      while (preNum.length > 3) {
        result = ',' + preNum.slice(-3) + result
        preNum = preNum.slice(0, preNum.length - 3)
      }
      if (preNum) {
        result = preNum + result
      }
      result = result + '.' + lastNum
      return sign + result
    } else {
      return num
    }
  },
  priceFormat(e) {
    return Number(e).toFixed(2)
  },
  priceFormat1(e) {
    if (Number(e) >= 0) {
      if (typeof e === 'number' && !isNaN(e)) {
        var result = ''
        e = Number(e.toString() || 0).toFixed(2)
        var numAry = e.toString().split('.')
        var preNum = numAry[0]
        var lastNum = numAry[1]
        while (preNum.length > 3) {
          result = ',' + preNum.slice(-3) + result
          preNum = preNum.slice(0, preNum.length - 3)
        }
        if (preNum) {
          result = preNum + result
        }
        result = result + '.' + lastNum
        return result
      } else {
        return e
      }
      // return Number(e).toFixed(2)
    } else {
      return '--'
    }
  },
  amountWFormat(intN) { // 向上取整
    if (typeof intN === 'number') {
      if (intN > 100000000) {
        return upFixed(intN / 100000000, 2) + '亿'
      } else if (intN > 10000) {
        return upFixed(intN / 10000, 2) + '万'
      } else {
        // 2021.12.16修改不要小数点
        return Math.ceil(intN)
      }
    } else {
      return intN
    }
  },
  amountFixFormat(intN) { // 四舍五入
    if (typeof intN === 'number') {
      if (intN > 100000000) {
        return (intN / 100000000).toFixed(2) + '亿'
      } else if (intN > 10000) {
        return (intN / 10000).toFixed(2) + '万'
      } else {
        return intN.toFixed(2) + ''
      }
    } else {
      return intN
    }
  },
  addSign(str) { // 删除"+"
    str = str + ''
    return str.split('+').join('')
  }
}

export default oVueFilter
